// import defaultOfertaForm from '@/util/offerConfigurator/defaultOfertaForm.js'
// import {clone} from '@/util/libUtil.js'

const defaultNoInterestForm = {
	razon: null,
	tipo: null,
	notas: '',
}

export default defaultNoInterestForm;
